module.exports = __webpack_public_path__ + "img/menu.1ab6f13c.svg";